import {get, post} from '@/lib/fetch.js'


export function WorkflowSubmitApi(data) {
    return post('/workflow/add', data)
}

export function WorkflowDetailApi(params) {
    return get('/workflow/detail', params)
}

export function WorkflowUpdateApi(params) {
    return post('/workflow/update', params)
}

export function WorkflowListApi(params) {
    return post('/workflow/list', params)
}

export function WorkflowDeleteApi(params) {
    return post('/workflow/delete', params)
}

export function TemplateAllApi(params) {
    return get('/workflow/all', params)
}

export function WorksListByFlowid(params){
	return get('/workflow/works/list', params)
}

export function WorkflowDropApi(params){
	return post('/workflow/drop', params)
}

export function WorkflowDeployAddApi(params, flowid){
	return post('/workflow/deploy/add?flowid=' + flowid, params)
}

export function WorkflowCommandAddApi(params, flowid){
	return post('/workflow/command/add?flowid=' + flowid, params)
}

export function WorkflowOneKeyAuditApi(params){
    return post('/workflow/onekey/audit', params)
}

export function WorkflowFinishApi(params){
    return post('/workflow/finish', params)
}